import chatbotRequest from '../http'
import type { DeleteChannelReq, DeleteChannelRes } from '../types/deleteChannel'

export function deleteChannelApi(data: DeleteChannelReq): Promise<DeleteChannelRes> {
    return chatbotRequest<DeleteChannelRes, DeleteChannelReq, DeleteChannelRes>({
        url: '/api/channel/delete',
        method: 'post',
        data,
    })
}